<template>
    <b-media v-if="blogPost" class="blog-post" :class="{ 'preview': preview }">
        <template v-if="preview" v-slot:aside>
            <b-img-lazy class="preview-image" rounded blank-color="#abc" :src="blogPost.cover_image" width="128" height="128"></b-img-lazy>
        </template>

        <h5 v-if="preview" class="title">
            <a v-if="blogPost.original_url" :href="blogPost.original_url" target="_blank">{{blogPost.title}}</a>
            <router-link v-else :to="url">{{blogPost.title}}</router-link>
        </h5>
        <h1 v-if="!preview" class="title">
            {{blogPost.title}}
        </h1>

        <b-img v-if="!preview" class="img-cover" blank-color="#abc" :src="blogPost.cover_image"></b-img>

        <div class="info" v-if="preview">
            <div class="date"><span v-tr>Published on|Publié le</span> {{blogPost.date_published | datetime}}</div>
        </div>

        <div class="content" v-if="preview" :class="{ 'hide-overflow': !blogPost.description }" v-html="blogPost.description || blogPost.content"></div>
        <div class="content" v-else v-html="blogPost.content"></div>

        <div v-if="!preview" class="keywords">
            <b-badge variant="light" class="p-2 m-1" v-for="word in keywords" :key="'keyword-' + word">{{word}}</b-badge>
        </div>

        <div v-if="preview" class="text-right">
            <a v-if="blogPost.original_url" :href="blogPost.original_url" target="_blank" class="text-primary"><span v-tr>Continue reading|Continuer la lecture</span> <i class="fal fa-chevron-right ml-1"></i></a>
            <router-link v-else :to="url" class="text-primary"><span v-tr>Continue reading|Continuer la lecture</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
        </div>
        <div v-else class="text-left mt-2">
            <router-link to="/blog" class="text-primary" size="sm"><i class="fal fa-chevron-left mr-1"></i> <span v-tr>Back to blog|Retour au blog</span></router-link>
        </div>

        <div class="footer" v-if="!preview">
            <div class="date">{{blogPost.date_published | datetime}}</div>
            <div class="author">
                <span class="mr-1" v-tr>Written by|Écrit par</span>
                <span class="author-name">{{blogPost.author}}</span>
            </div>
            <div class="clearfix"></div>
        </div>
    </b-media>
</template>

<script>
    import Network from "../helpers/Network";

    export default {
        name: `blog-post`,
        props: {
            value: {
                type: Object
            },
            id: {
                type: String
            },
            preview: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            url() {
                if (this.blogPost.original_url) {
                    return this.blogPost.original_url;
                } else if (this.blogPost.url) {
                    return `/blog/post/${this.blogPost.url}`;
                } else {
                    return `/blog/post/${this.blogPost.id}`;
                }
            },
            blogPost() {
                return this.value || this.post;
            },
            keywords() {
                if (this.blogPost && this.blogPost.tags) {
                    return JSON.parse(this.blogPost.tags);
                } else {
                    return [];
                }
            }
        },
        data() {
            return {
                post: null
            }
        },
        created() {
            if (!this.value && this.id) {
                Network.get(`/blog/post/${this.id}`)
                    .then(resp => {
                        this.post = resp.data;
                    });
            }
        },
        methods: {
            navigated() {
                this.$emit(`navigated`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .blog-post {
        & + .blog-post {
            border-top: 1px solid #eee;
            padding-top: 15px;
        }

        ::v-deep {
            h1.title {
                font-family: perpetua, serif !important;
                font-size: 32pt !important;
                letter-spacing: 0 !important;
                text-transform: none !important;
                font-weight: 400 !important;
                margin-bottom: 0 !important;
            }

            .content {
                min-height: 80px;
                margin-bottom: 10px;
                text-align: justify;
                text-justify: inter-word;
                font-family: "Garamond", serif;
                font-size: 21px;

                h2, h3, h4, h5 {
                    font-weight: 700;
                    font-family: "Garamond", serif !important;
                    text-align: left;
                }

                h2 {
                    font-size: 28px;
                }

                h3 {
                    font-size: 26px;
                }

                h4 {
                    font-size: 24px;
                }

                h5 {
                    font-size: 22px;
                }

                h1.title,
                * {
                    max-width: 100%;
                }

                .ql-align-left {
                    text-align: left;
                }

                .ql-align-center {
                    text-align: center;
                }

                .ql-align-justify {
                    text-align: justify;
                }

                .ql-align-right {
                    text-align: right;
                }

                @media(max-width: 600px) {
                    h2 {
                        font-size: 26px;
                    }

                    h3 {
                        font-size: 23px;
                    }

                    h4 {
                        font-size: 21px;
                    }

                    h5 {
                        font-size: 18px;
                    }
                }
            }

            .footer {
                padding-top: 10px;
                border-top: 1px solid rgba(0, 0, 0, 0.1);
                margin: 15px 0;
            }

            .preview-image {
                object-fit: cover;
            }

            h1 {
                padding: 0;
                color: #000;
                max-width: 100%;
            }

            .author {
                .author-name {
                    font-weight: 500;
                }
            }

            .date {
                opacity: 0.7;
                float: right;
                font-style: italic;
                font-size: 10pt;
            }

            p {
                margin-bottom: 0;
            }
        }

        &:not(.preview) {
            .title {
                text-align: center;
                margin-bottom: 20px;
                padding: 15px;
            }

            .img-cover {
                width: 100%;
                max-height: 500px;
                object-fit: cover;
                margin-bottom: 20px;
                border-radius: 20px;
                box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
        }

        &.preview ::v-deep {
            @media(min-width: 600px) {
                padding: 20px;
            }

            .content {
                min-height: 50px;
                max-height: 120px;
                overflow: hidden;
                text-overflow: ellipsis;
                position: relative;
                font-family: inherit !important;
                letter-spacing: 0.5px;
                font-size: 10pt;
                font-weight: normal;
                color: #333;
                line-height: 1.42;

                * {
                    line-height: inherit;
                    color: inherit;
                    font-size: inherit;
                    font-weight: inherit;
                    font-family: inherit !important;
                }

                h2, h3, h4, h5 {
                    margin-bottom: 0;
                }

                &.hide-overflow:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    box-shadow: inset 0 -20px 20px white;
                    height: 20px;
                }
            }

            .date {
                float: none;
                margin-bottom: 10px;
            }
        }
    }
</style>
